import { render, staticRenderFns } from "./AddressListV2.vue?vue&type=template&id=79524992&"
import script from "./AddressListV2.vue?vue&type=script&lang=js&"
export * from "./AddressListV2.vue?vue&type=script&lang=js&"
import style0 from "./AddressListV2.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports